import { DomainBase } from "./DomainBase";

export class UnitClass extends DomainBase {
    constructor() {
        super();
        this.name = '';
    }
}